export const DUMMY_DATA = [
  {
    registrationNumber: 'JAK001062300',
    createdAt: '22 Nov 2023 19:59:53',
    fullname: 'Francis F',
    nik: '3175035605000009',
    age: 32,
    shirtSize: 'S',
    email: 'jakregist@gmail.com',
    type: 'MANUAL',
    phoneNumber: '0821331331313',
  },
  {
    registrationNumber: 'JAK001062301',
    createdAt: '22 Nov 2023 19:59:53',
    fullname: 'Francis F',
    nik: '3175035605000009',
    age: 32,
    shirtSize: 'S',
    email: 'jakregist@gmail.com',
    type: 'ACTIVE',
    phoneNumber: '0821331331313',
  },
  {
    registrationNumber: 'JAK001062302',
    createdAt: '22 Nov 2023 19:59:53',
    fullname: 'Francis F',
    nik: '3175035605000009',
    age: 32,
    shirtSize: 'S',
    email: 'jakregist@gmail.com',
    type: 'RENEW',
    phoneNumber: '0821331331313',
  },
  {
    registrationNumber: 'JAK001062303',
    createdAt: '22 Nov 2023 19:59:53',
    fullname: 'Francis F',
    nik: '3175035605000009',
    age: 32,
    shirtSize: 'S',
    email: 'jakregist@gmail.com',
    type: 'NEW',
    phoneNumber: '0821331331313',
  },
]

export const MATCH_STATUS_DUMMY = ['UPCOMING', 'LIVE', 'FULL TIME']

export const LIGA_SATU_CLUB = [
  {
    id: 1,
    name: 'AREMA FC',
    slug: 'arema-fc',
    color: '#093782',
    icon: 'https://nos.wjv-1.neo.id/jakmania-bucket/assets/PNG/Arema%20FC.png',
  },
  {
    id: 2,
    name: 'Bali United',
    slug: 'bali-united',
    color: '#C80F2E',
    icon: 'https://nos.wjv-1.neo.id/jakmania-bucket/assets/PNG/Bali%20United.png',
  },
  {
    id: 3,
    name: 'Barito Putera',
    slug: 'barito-putera',
    color: '#F6CB02',
    icon: 'https://nos.wjv-1.neo.id/jakmania-bucket/assets/PNG/Barito%20Putera.png',
  },
  {
    id: 4,
    name: 'Bhayangkara FC',
    slug: 'bhayangkara',
    color: '#0F5B2D',
    icon: 'https://nos.wjv-1.neo.id/jakmania-bucket/assets/PNG/Bhayangkara.png',
  },
  {
    id: 5,
    name: 'Borneo FC Samarinda',
    slug: 'borneo-fc',
    color: '#A0A0A0',
    icon: 'https://nos.wjv-1.neo.id/jakmania-bucket/assets/PNG/Borneo%20Samarinda.png',
  },
  {
    id: 6,
    name: 'Dewa United',
    slug: 'dewa-united',
    color: '#E1B763',
    icon: 'https://nos.wjv-1.neo.id/jakmania-bucket/assets/PNG/Dewa%20United.png',
  },
  {
    id: 7,
    name: 'Madura United',
    slug: 'madura-united',
    color: '#C81402',
    icon: 'https://nos.wjv-1.neo.id/jakmania-bucket/assets/PNG/Madura%20United.png',
  },
  {
    id: 8,
    name: 'PERSEBAYA Surabaya',
    slug: 'persebaya-surabaya',
    color: '#0B8441',
    icon: 'https://nos.wjv-1.neo.id/jakmania-bucket/assets/PNG/Persebaya%20Surabaya.png',
  },
  {
    id: 9,
    name: 'PERSIB Bandung',
    slug: 'persib-bandung',
    color: '#1933AC',
    icon: 'https://nos.wjv-1.neo.id/jakmania-bucket/assets/PNG/Persib.png',
  },
  {
    id: 10,
    name: 'PERSIJA Jakarta',
    slug: 'persija-jakarta',
    color: '#E61A19',
    icon: 'https://nos.wjv-1.neo.id/jakmania-bucket/assets/PNG/Persija.png',
  },
  {
    id: 11,
    name: 'PERSIK Kediri',
    slug: 'persik-kediri',
    color: '#6E31A6',
    icon: 'https://nos.wjv-1.neo.id/jakmania-bucket/assets/PNG/Persik.png',
  },
  {
    id: 12,
    name: 'PERSIKABO 1973',
    slug: 'persikabo-1973',
    color: '#147741',
    icon: 'https://nos.wjv-1.neo.id/jakmania-bucket/assets/PNG/Persikabo.png',
  },
  {
    id: 13,
    name: 'PERSIS Solo',
    slug: 'persis-solo',
    color: '#E00820',
    icon: 'https://nos.wjv-1.neo.id/jakmania-bucket/assets/PNG/Persis.png',
  },
  {
    id: 14,
    name: 'PERSITA Tangerang',
    slug: 'persita-tangerang',
    color: '#613493',
    icon: 'https://nos.wjv-1.neo.id/jakmania-bucket/assets/PNG/Persita.png',
  },
  {
    id: 15,
    name: 'PSIS Semarang',
    slug: 'psis-yogyakarta',
    color: '#134A7A',
    icon: 'https://nos.wjv-1.neo.id/jakmania-bucket/assets/PNG/PSIS.png',
  },
  {
    id: 16,
    name: 'PSM Makassar',
    slug: 'psm-makasar',
    color: '#FE0000',
    icon: 'https://nos.wjv-1.neo.id/jakmania-bucket/assets/PNG/PSM%20Makassar.png',
  },
  {
    id: 17,
    name: 'PSS Sleman',
    slug: 'pss-sleman',
    color: '#00A859',
    icon: 'https://nos.wjv-1.neo.id/jakmania-bucket/assets/PNG/PSS%20Sleman.png',
  },
  {
    id: 18,
    name: 'RANS Nusantara',
    slug: 'rans-nusantara',
    color: '#612BD7',
    icon: 'https://nos.wjv-1.neo.id/jakmania-bucket/assets/PNG/Rans%20Nusantara.png',
  },
]
